import { useQuery } from "@tanstack/react-query";
import { getRevenueStoreApi } from "../../services";
import { useAccountStore, useRevenueStore } from "../../store";

export const useGetRevenueStoreApi = () => {
  const { accountId, endDate, startDate } = useRevenueStore();

  const { info } = useAccountStore();


  const { data, isLoading } = useQuery({
    queryKey: ["revenue-store", startDate, endDate, accountId],
    queryFn: () => getRevenueStoreApi(accountId, startDate, endDate),
    enabled: !!startDate && !!endDate && !!info?.role,
  });
  return {
    revenueStore: data,
    isLoading,
  };
};
